import { CustomPagination } from 'components/helpers/AlgoliaSearch/CustomPagination';
import { Table, Thead, Tr, Tbody } from 'react-super-responsive-table';
import TcSearchHeadings from './_SearchHeadings';
import TcHits from 'components/helpers/AlgoliaSearch/TcHits';
import useScreenWidth from 'lib/util/useScreenWidth';
import { classnames } from 'tailwindcss-classnames';
import { useCallback, useState } from 'react';
import { env } from 'lib/env';
import { logWarning } from 'lib/util/errors';
import { useSortBy } from 'react-instantsearch-hooks';

const StableSortItems = [
  { label: 'sortDate', value: `${env.ALGOLIA_INDEX_NAME}_date_desc` },
  { label: 'sortName', value: `${env.ALGOLIA_INDEX_NAME}_name_asc` },
  { label: 'sortNameDesc', value: `${env.ALGOLIA_INDEX_NAME}_name_desc` },
  { label: 'sortCity', value: `${env.ALGOLIA_INDEX_NAME}_city_asc` },
  { label: 'sortCityDesc', value: `${env.ALGOLIA_INDEX_NAME}_city_desc` },
  { label: 'sortState', value: `${env.ALGOLIA_INDEX_NAME}_state_asc` },
  { label: 'sortStateDesc', value: `${env.ALGOLIA_INDEX_NAME}_state_desc` },
  { label: 'sortAllos', value: `${env.ALGOLIA_INDEX_NAME}_allos_desc` },
  { label: 'sortAllosAsc', value: `${env.ALGOLIA_INDEX_NAME}_allos_asc` },
  { label: 'sortProgramType', value: `${env.ALGOLIA_INDEX_NAME}_programtype_asc` },
  { label: 'sortProgramTypeDesc', value: `${env.ALGOLIA_INDEX_NAME}_programtype_desc` },
  { label: 'sortSurvivorship', value: `${env.ALGOLIA_INDEX_NAME}_survivorship_asc` },
  { label: 'sortSurvivorshipDesc', value: `${env.ALGOLIA_INDEX_NAME}_survivorship_desc` },
  { label: 'defaultIndex', value: `${env.ALGOLIA_INDEX_NAME}` },
];

const getSortItem = (index: string) => {
  const normalMatch = index.toLocaleLowerCase() ?? env.ALGOLIA_INDEX_NAME;
  let match = StableSortItems.find((item) => item.value === normalMatch);
  if (!match) {
    logWarning(`Request to sort by missing index ${normalMatch}, defaulting to relevence.`);
    match =
      StableSortItems.find((item) => item.value === env.ALGOLIA_INDEX_NAME) ?? StableSortItems[0]; // default to first item if not found
  }
  return match;
};

const TcHitsSection = ({ txId, nbHits }: { txId: string; nbHits: number }): JSX.Element => {
  const currentScreenWidth = useScreenWidth();
  // Setup sorting by a single property
  const { refine } = useSortBy({
    items: StableSortItems,
  });
  const [sortIndicator, setIndicator] = useState({
    columName: 'Date' as string,
    isAscending: false,
  });

  const sorting = useCallback(
    (column: string, isAscending: boolean) => {
      let sortIndex = `${env.ALGOLIA_INDEX_NAME}_${column}_asc`;
      if (isAscending) {
        sortIndex = `${env.ALGOLIA_INDEX_NAME}_${column}_asc`;
      } else {
        sortIndex = `${env.ALGOLIA_INDEX_NAME}_${column}_desc`;
      }
      refine(getSortItem(sortIndex).value);
      setIndicator({
        ...sortIndicator,
        columName: column,
        isAscending: isAscending ? true : false,
      });
    },
    [sortIndicator, refine]
  );

  return (
    <>
      {currentScreenWidth > 767 && (
        <Table className={classnames('max-w-[1024px]')}>
          <Thead>
            <Tr className={classnames('text-left', 'font-bold')}>
              {nbHits > 0 && <TcSearchHeadings sortTable={sorting} sortIndicator={sortIndicator} />}
            </Tr>
          </Thead>
          <Tbody>
            <TcHits txId={txId} />
          </Tbody>
        </Table>
      )}
      {currentScreenWidth < 768 && <TcHits txId={txId} />}
      <div>
        <CustomPagination padding={1} />
      </div>
    </>
  );
};

export default TcHitsSection;
